import axios from "axios";
import { useCallback, useEffect, useRef, useState } from "react";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("c360_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && !String(e.config?.url).includes("/auth/")) {
      localStorage.removeItem("c360_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail ?? e?.response?.data?.error;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.message || JSON.stringify(d);
}

export function useFetch(path, { interval, deps = [] } = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const mounted = useRef(true);
  const load = useCallback(async () => {
    if (!path) return;
    try {
      const r = await api.get(path);
      if (mounted.current) { setData(r.data); setError(null); }
    } catch (e) {
      if (mounted.current) setError(errMsg(e));
    } finally {
      if (mounted.current) setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);
  useEffect(() => {
    mounted.current = true;
    setLoading(true);
    load();
    let t;
    if (interval) t = setInterval(load, interval);
    return () => { mounted.current = false; if (t) clearInterval(t); };
  }, [load, interval]);
  return { data, loading, error, reload: load, setData };
}

export const fmtTime = (s) => (s ? new Date(s).toLocaleString([], { dateStyle: "medium", timeStyle: "short" }) : "—");
export const fmtClock = (s) => (s ? new Date(s).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : "");
export const fmtPhone = (p) => (p ? `+${p}` : "");
